import { EligibilitySpecialConditionsScreen } from "@/interactors/EligibilitySpecialConditionsScreen";

export default function SpecialConditions() {
  return <EligibilitySpecialConditionsScreen />;
}
